import { filter } from 'lodash';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Divider,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Backdrop,
  CircularProgress,
  Select
} from '@material-ui/core';
import moment from 'moment';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

import { useConstantsContext } from '../../../context/constants_context';
import { baseUrl, currencies } from '../../../utils/constants';
import Scrollbar from '../../Scrollbar';
import SearchNotFound from '../../SearchNotFound';
import { ClientListHead } from '../../_dashboard/clients';
import Controls from '../../controls/Controls';

if (pdfjsLib && pdfjsWorker) {
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
}

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'desc', label: 'Description', alignRight: false },
  { id: 'counts', label: '# of Items', alignRight: false },
  { id: 'totamt', label: 'Total Amount', alignRight: false }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function FileReports() {
  const m = moment();
  const { payCycles } = useConstantsContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [begDate, setBegDate] = useState(sessionStorage.getItem('payCycleId'));
  const [currency, setCurrency] = useState(3);
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [provider, setProvider] = useState(sessionStorage.getItem('oldRefId'));
  const [docType, setDocType] = useState('pdf');
  const [dataType, setDataType] = useState('2');
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [iframeSrc, setIframeSrc] = useState('');
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });

  const filename = `fileReport_${moment().format('DD-MMM-YYYY')}.${docType}`;
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    // getProviderClaims();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('begDate in useEffect', begDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isListEmpty = filteredUsers.length === 0;

  // 176
  const getSummary = () => {
    setLoading(true);
    setDataList([]);
    fetch(
      `${baseUrl}/api/client/getCountResults?refId=${begDate}&dataType=${dataType}&other=${currency}&description=''`
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          console.log('returned getCountResults Summary list', result);
          setDataList(result);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error in getCountResults!: ${error}`, 'error');
        }
      );
  };

  const downloadDocument = () => {
    console.log('dataType', dataType);
    if (dataType === '1') {
      downloadDesignation();
    }
    if (dataType === '2') {
      downloadRevenue();
    }
  };

  const downloadDesignation = () => {
    setLoading(true);
    fetch(
      `${baseUrl}/api/report/getnew/FileReport/${docType}/Designation/${dataType}/${currency}/${begDate}/0`
    )
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Downloading File Designations!: ${error}`, 'error');
        }
      );
  };

  const downloadRevenue = () => {
    setLoading(true);
    const filenimo = `fileRevenue_${moment().format('DD-MMM-YYYY')}.${docType}`;
    fetch(
      `${baseUrl}/api/report/getnew/FileRevenue/${docType}/Contributions/${dataType}/${currency}/${begDate}/0`
    )
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filenimo}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Downloading File Revenue!: ${error}`, 'error');
        }
      );
  };

  const handlePrintPreview = async () => {
    setLoading(true);
    try {
      let url = '';
      if (dataType === '2')
        url = `${baseUrl}/api/report/getnew/FileRevenue/${docType}/Contributions/${dataType}/${currency}/${begDate}/0`;
      else
        url = `${baseUrl}/api/report/getnew/FileReport/${docType}/Designation/${dataType}/${currency}/${begDate}/0`;

      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const blob = await response.blob();
      const fileURL = URL.createObjectURL(blob);
      setIframeSrc(fileURL);
      // setOpenPreviewDialog(true);
    } catch (error) {
      console.error('Error fetching print preview:', error);
      notifyPopup(`Error fetching payroll report: ${error.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={2}>
        <Grid item xs={5} sm={2}>
          <Typography component="span" variant="h4" gutterBottom>
            File Reports
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl className={classes.formControl}>
            <InputLabel id="selectoc">Change Type</InputLabel>
            <Select
              labelId="selectDatalabel"
              id="dataType"
              value={dataType}
              size="small"
              variant="standard"
              onChange={(e) => {
                setDataType(e.target.value);
              }}
            >
              <MenuItem value="1">Designations</MenuItem>
              <MenuItem value="2">Contributions</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={1}>
          <FormControl className={classes.formControl}>
            <InputLabel id="selectDoc">Doc Type</InputLabel>
            <Select
              labelId="selectDoclabel"
              id="docType"
              value={docType}
              size="small"
              variant="standard"
              onChange={(e) => {
                setDocType(e.target.value);
              }}
            >
              <MenuItem value="pdf">PDF</MenuItem>
              <MenuItem value="xls">XLS</MenuItem>
              <MenuItem value="doc">WORD</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            id="standard-select-currency"
            style={{ width: 180, height: 30, pb: 2 }}
            select
            size="small"
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
          >
            <MenuItem key="" value="0">
              Select Currency
            </MenuItem>
            {currencies.map((option) => (
              <MenuItem key={option.refId} value={option.refId}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth>
            <InputLabel id="payCycleLbl">Pay Period</InputLabel>
            <Select
              id="payCycleID"
              value={begDate}
              name="payCycleID"
              fullWidth
              size="small"
              variant="outlined"
              onChange={(e) => {
                setBegDate(e.target.value);
              }}
            >
              <MenuItem key="" value="">
                Not Selected
              </MenuItem>
              {payCycles.slice(0, 12).map((item) => (
                <MenuItem key={item.payCycleId} value={item.payCycleId}>
                  {moment(item.payDate).format('YYYY-MM-DD')}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* <Grid item xs={12} sm={2}>
          <FormControl fullWidth>
            <InputLabel id="payCycleLbl">Pay Period</InputLabel>
            <Select
              id="payCycleID"
              value={endDate}
              name="payCycleID"
              fullWidth
              size="small"
              variant="outlined"
              onChange={(e) => {
                setEndDate(e.target.value);
              }}
            >
              <MenuItem key="" value="">
                Not Selected
              </MenuItem>
              {payCycles.slice(0, 12).map((item) => (
                <MenuItem key={item.payCycleId} value={item.payCycleId}>
                  {moment(item.payDate).format('YYYY-MM-DD')}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
        {/* <Grid item xs={12} sm={1}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={() => getSummary()}
          >
            Refresh
          </Button>
        </Grid> */}
        <Grid item xs={12} sm={1}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={() => handlePrintPreview()}
          >
            Preview
          </Button>
        </Grid>
        <Grid item xs={12} sm={1} ml={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={() => downloadDocument()}
          >
            Download
          </Button>
        </Grid>
      </Grid>

      <Divider style={{ background: '#832025', height: 2, margin: 10 }} variant="middle" />

      {iframeSrc ? (
        <Worker>
          <div style={{ height: '100vh', width: '100%' }}>
            <Viewer fileUrl={iframeSrc} plugins={[defaultLayoutPluginInstance]} />
          </div>
        </Worker>
      ) : (
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table size="small" aria-label="a dense table">
                <ClientListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={dataList.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      /* eslint-disable camelcase */
                      const { description, noOfItems, totalAmount } = row;
                      const isItemSelected = selected.indexOf(description) !== -1;

                      return (
                        <StyledTableRow
                          hover
                          key={description}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell padding="checkbox" />

                          <TableCell align="left">{description}</TableCell>
                          <TableCell align="left">{noOfItems}</TableCell>
                          <TableCell align="left">{totalAmount.toFixed(2)}</TableCell>
                        </StyledTableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isListEmpty && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <Controls.Notification notify={notify} setNotify={setNotify} />
          </Scrollbar>

          <TablePagination
            className={classes.tableFooter}
            rowsPerPageOptions={[8, 16, 24]}
            component="div"
            count={dataList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      )}
    </Container>
  );
}
